
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    littleMessage: {
      type: String,
      required: false,
      default: 'I am default props',
    },
    littleList: {
      type: Array,
      required: false,
      default: function () {
        return ["This", "is", "default"]
      }
    }
  }
});
